import { LoaderInterceptor } from "src/helpers/loader.interceptor";
import {
  I18n,
  CustomDatepickerI18n,
  NgbDatePTParserFormatter,
} from "./../helpers/custom.datepicker";
import { BrowserModule } from "@angular/platform-browser";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtInterceptor } from "src/helpers/jwt.interceptor";
import { RefreshTokenInterceptor } from "src/helpers/refresh-token.interceptor";
import { ErrorInterceptor } from "src/helpers/error.interceptor";
import { UnauthorizedComponent } from "src/pages/unauthorized/unauthorized.component";
import { NavbarComponent } from "src/pages/theme/navbar/navbar.component";
import {
  NgbModule,
  NgbDatepickerI18n,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import { JoyrideModule, JoyrideStepComponent } from "ngx-joyride";

import { CKEditorModule } from "ng2-ckeditor";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { NgSelectModule } from "@ng-select/ng-select";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MaterialModule } from "src/app/material.module";
import { NicknamePipeModule } from "src/app/nickname-pipe.module";
import { BtnLoaderModule } from "src/app/btnloader.module";
import { TemplateFormModule } from "src/app/template-form.module";
import { SharedModule } from "src/app/shared.module";

import {
  PerfectScrollbarModule,
  PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG,
} from "ngx-perfect-scrollbar";

import { ImageCropperModule } from "ngx-image-cropper";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { HomeComponent } from "@page/home/home.component";
import { AuthComponent } from "@page/auth/auth.component";
import { MenuComponent } from "@page/theme/menu/menu.component";
import { FooterComponent } from "@page/theme/footer/footer.component";
import { ProjectHistoricsComponent } from "@page/project-historics/project-historics.component";
import { PublicProfileComponent } from "@page/public-profile/public-profile.component";
import { InviteLinkComponent } from "@component/invite-link/invite-link.component";
import { ProjectRemindersComponent } from "@page/project-reminders/project-reminders.component";
import { UserSuggestionsComponent } from "@page/user-suggestions/user-suggestions.component";
import { MyStudentsComponent } from "@page/my-students/my-students.component";
import { InvitationsComponent } from "@page/invitations/invitations.component";
import { TranslationPageComponent } from "@page/translation-page/translation-page.component";
import { OverviewComponent } from "@page/overview/overview.component";
import { TextStructureCycleComponent } from "@page/text-structure-cycle/text-structure-cycle.component";

import { ModalDeleteComponent } from "@component/modal-delete/modal-delete.component";
import { ModalAffiliationComponent } from "@component/modal-affiliation/modal-affiliation.component";
import { DocumentPipe } from "../pipes/document.pipe";

import { LoaderComponent } from "@component/loader/loader.component";
import { ModalProjectComponent } from "@component/modal-project/modal-project.component";

import { ModalInvitationComponent } from "@component/modal-invitation/modal-invitation.component";
import { ModalProjectStatusComponent } from "@component/modal-project-status/modal-project-status.component";
import { NgxMaskModule } from "ngx-mask";
import { AlignmentButtonsComponent } from "@component/alignment-buttons/alignment-buttons.component";
import { ModalCommentsComponent } from "../components/modal-comments/modal-comments.component";
import { CircularProgressBarComponent } from "@component/circular-progress-bar/circular-progress-bar.component";
import { ModalUsersAccessComponent } from "@component/modal-users-access/modal-users-access.component";
import { ModalStudentProfileComponent } from "@component/modal-student-profile/modal-student-profile.component";
import { ManualPageComponent } from "@page/manuals/manual-page.component";
import { ModalPasteFromWordComponent } from "@component/modal-paste-from-word/modal-paste-from-word.component";
import { CardRepositoryComponent } from "@component/card-repository/card-repository.component";
import { ModalRepositoryComponent } from "@component/modal-repository/modal-repository.component";
import { ModalDeleteRepositoryComponent } from "@component/modal-delete-repository/modal-delete-repository.component";
import { ModalResearcherProfileComponent } from "@component/modal-researcher-profile/modal-researcher-profile.componente";
import { ModalAddBaseStringComponent } from '@component/modal-add-base-string/modal-add-base-string.component';

import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import {
  featureStateName,
  menuReducers,
  appFeatureStateName,
  appReducers,
} from "./store";
import { DocHistoryEffect } from "./store/app.effects";
import { ModalRepositoriesComponent } from "@component/modal-repositories/modal-repositories.component";
import { BasicOfMetodologyComponent } from "@page/basic-of-metodology/basic-of-metodology.component";
import { ModalOpenaiDialogComponent } from "@component/modal-openai-dialog/modal-openai-dialog.component";
import { SubscriptionComponent } from "@page/subscription/subscription.component";
import { FirstWordsPlanComponent } from "../pages/first-words-plan/first-words-plan.component";
import { SecondWordsPlanComponent } from "../pages/second-words-plan/second-words-plan.component";
import { ThirdWordsPlanComponent } from "../pages/third-words-plan/third-words-plan.component";
import { FourthWordsPlanComponent } from "../pages/fourth-words-plan/fourth-words-plan.component";
import { ModalBuyWordsComponent } from "@component/modal-buy-words/modal-buy-words.component";
import { ModalLiteratureRevisionComponent } from "../components/modal-literature-revision/modal-literature-revision.component";
import { ModalSetInstitutionComponent } from "../components/modal-set-institution/modal-set-institution.component";
import { ExtractComponent } from "@component/extract/extract.component";
import { ModalPendingPixComponent } from "../components/modal-pending-pix/modal-pending-pix.component";
import { ModalPayPixComponent } from "../components/modal-pay-pix/modal-pay-pix.component";
import { ModalReportsComponent } from "@component/modal-reports/modal-reports.component";
import { ModalAttendingComponent } from "@component/modal-attending/modal-attending.component";
import { ModalSatisfactionSurveyComponent } from "@component/modal-satisfaction-survey/modal-satisfaction-survey.component";
import { PaymentMethodComponent } from "@page/payment-method/payment-method.component";
import { CardComponent } from "@page/card/card.component";
import { WhatsappIconComponent } from "@component/whatsapp-icon/whatsapp-icon.component";
import { ModalViewBibtexComponent } from '@component/modal-view-bibtex/modal-view-bibtex.component'
import { CardProjectComponent } from "@component/card-project/card-project.component";
import { ModalTransferComponent } from "@component/modal-transfer/modal-transfer.component";
import { ModalEditTokenComponent } from '@component/modal-edit-token/modal-edit-token.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: true,
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AuthComponent,
    UnauthorizedComponent,
    NavbarComponent,
    MenuComponent,
    FooterComponent,
    LoaderComponent,
    ModalProjectComponent,
    ModalDeleteComponent,
    ModalDeleteRepositoryComponent,
    ModalAffiliationComponent,
    ProjectHistoricsComponent,
    PublicProfileComponent,
    InviteLinkComponent,
    DocumentPipe,
    ModalInvitationComponent,
    ModalProjectStatusComponent,
    ProjectRemindersComponent,
    UserSuggestionsComponent,
    InvitationsComponent,
    TranslationPageComponent,
    ManualPageComponent,
    BasicOfMetodologyComponent,
    OverviewComponent,
    TextStructureCycleComponent,
    MyStudentsComponent,
    ModalCommentsComponent,
    CircularProgressBarComponent,
    ModalUsersAccessComponent,
    ModalStudentProfileComponent,
    ModalPasteFromWordComponent,
    CardRepositoryComponent,
    ModalRepositoryComponent,
    ModalResearcherProfileComponent,
    ModalRepositoriesComponent,
    ModalOpenaiDialogComponent,
    SubscriptionComponent,
    PaymentMethodComponent,
    FirstWordsPlanComponent,
    SecondWordsPlanComponent,
    ThirdWordsPlanComponent,
    FourthWordsPlanComponent,
    ModalBuyWordsComponent,
    ModalSetInstitutionComponent,
    ExtractComponent,
    ModalPendingPixComponent,
    ModalPayPixComponent,
    ModalLiteratureRevisionComponent,
    ModalReportsComponent,
    ModalAttendingComponent,
    ModalSatisfactionSurveyComponent,
    CardComponent,
    WhatsappIconComponent,
    ModalAddBaseStringComponent,
    ModalViewBibtexComponent,
    ModalTransferComponent,
    ModalEditTokenComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  imports: [
   CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    MaterialModule,
    NicknamePipeModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    ImageCropperModule,
    NgxMaskModule.forRoot(),
    BtnLoaderModule,
    TemplateFormModule,
    JoyrideModule.forRoot(),
    StoreModule.forRoot({}),
    StoreModule.forFeature(featureStateName, menuReducers),
    StoreModule.forFeature(appFeatureStateName, appReducers),
    // EffectsModule.forRoot([DocHistoryEffect]),
    SharedModule,
    MatNativeDateModule,
    CKEditorModule,
  ],
  entryComponents: [
    ModalProjectComponent,
    ModalDeleteComponent,
    ModalDeleteRepositoryComponent,
    ModalAffiliationComponent,
    ModalInvitationComponent,
    ModalProjectStatusComponent,
    ModalCommentsComponent,
    ModalUsersAccessComponent,
    ModalStudentProfileComponent,
    ModalPasteFromWordComponent,
    JoyrideStepComponent,
    ModalRepositoryComponent,
    ModalResearcherProfileComponent,
    ModalRepositoriesComponent,
    ModalOpenaiDialogComponent,
    ModalBuyWordsComponent,
    ModalSetInstitutionComponent,
    ModalPendingPixComponent,
    ModalPayPixComponent,
    ModalLiteratureRevisionComponent,
    ModalReportsComponent,
    ModalAttendingComponent,
    ModalSatisfactionSurveyComponent,
    ModalAddBaseStringComponent,
    ModalViewBibtexComponent,
    ModalTransferComponent,
    ModalEditTokenComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
    [{ provide: NgbDateParserFormatter, useClass: NgbDatePTParserFormatter }],
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
